import React, { useEffect, useState } from 'react'
import useManageTranslate from './useManageTranslate';
import AddEditForm from '../../../../sharedComponents/AddEditForm'
import DeleteConfirm from '../../../../sharedComponents/DeleteConfirm';
import Modal from 'react-modal';
import { PencilIcon, TrashIcon, MagnifyingGlassIcon } from '@heroicons/react/24/solid'
import { toast } from 'react-toastify';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    height: 'auto',
    width: '500px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)', // This sets the overlay color
    zIndex: 2000
  },
};

const items = [
  {
    title: 'ภาษาไทย',
    name: 'thai',
    type: 'text',
  },
  {
    title: 'ภาษาญี่ปุ่น',
    name: 'japanese',
    type: 'text',
  },
  {
    title: 'ใช้บ่อย ไว้ด้านบน',
    name: 'priority',
    type: 'boolean',
  },
];

const initialValue = {
  thai: '',
  japanese: '',
  priority: false,
  isHide: false,
}

const Translate = () => {
  
  const {
    error,
    translates,
    getTranslates,
    registerTranslate,
    updateTranslate,
    hideTranslate
  } = useManageTranslate()

  const [mode, setMode] = useState('register')
  const [modalTitle, setModalTitle] = useState('ลงทะเบียน ประโยคใหม่')
  const [searchKeyword, setSearchKeyword] = useState('')

  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const [translate, setTranslate] = useState(initialValue);

  // Filter translates based on search keyword
  const filteredTranslates = translates && translates.length > 0 ? translates.filter(item => 
    item.thai.toLowerCase().includes(searchKeyword.toLowerCase())
  ) : [];

  const handleInputChange = (e) => {
    const { name, type, checked, value } = e.target;
    if (type === 'checkbox') {
      // For a checkbox, use the 'checked' property
      setTranslate(prevOption => ({
        ...prevOption,
        [name]: checked
      }));
    } else {
      // For other inputs, use the 'value' property
      setTranslate(prevOption => ({
        ...prevOption,
        [name]: value
      }));
    }
  };

  const openForm = async (isEdit,id) => {
    if(isEdit){
      const transaleToEdit = translates.find(w => w.id === id);
      if(transaleToEdit) {
        setTranslate(transaleToEdit);
        setModalTitle('แก้ไขข้อมูลเดิม');
        setMode('edit');
      }

    }else{
      setTranslate(initialValue)
      setMode('register')
      setModalTitle('ลงทะเบียน ประโยคใหม่')
    }
    setIsFormOpen(true);
  };

  const closeForm = () =>{
    setIsFormOpen(false);
  }

  const openConfirm = async (id) => {
    const translateToDelete = translates.find(w => w.id === id);
    if(translateToDelete) {
      setTranslate(translateToDelete);
      setIsConfirmOpen(true)
    }
  };

  const closeConfirm = () =>{
    setIsConfirmOpen(false)
  }

  const handleUpdateTranslate = async () => {
    try {
      const response = await updateTranslate(translate);
      if(response){
        toast.success('Translation updated successfully!');
        closeForm();
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || "An unexpected error occurred.";
      toast.error(errorMessage);
    }
  };
  
  const handleDeleteTranslate = async () => {
      const response = await hideTranslate(translate.id);
      console.log(response)
      if(response){
        toast.success('Translate deleted successfully!');
        closeConfirm();
      }else{
        toast.error('มีบางอย่างผิดพลาด');
      }
  };

  const handleRegisterTranslate = async () => {
    try {
        const returnResult = await registerTranslate(translate);
        if (returnResult) {
          toast.success('Translate registered successfully!');
          closeForm();
        } else {
          toast.error(error);
        }
    } catch (err) {

    }
  };

  useEffect(() => {
    getTranslates()
  },[])
  

  return (
    <div className="p-4">
      <Modal
        isOpen={isFormOpen}
        onRequestClose={closeForm}
        style={customStyles}
        ariaHideApp={false}
      >
        <AddEditForm 
          items={items} 
          name={modalTitle} 
          data={translate} 
          mode={mode}
          closeForm={closeForm}
          handleInputChange={handleInputChange}
          handleRegister={handleRegisterTranslate}
          handleUpdate={handleUpdateTranslate}
          stateValue={translate}
        />
      </Modal>
      <Modal
        isOpen={isConfirmOpen}
        onRequestClose={closeConfirm}
        style={customStyles}
        ariaHideApp={false}
      >
        <DeleteConfirm 
          items={items} 
          data={translate} 
          closeConfirm={closeConfirm}
          confirmFunction={handleDeleteTranslate}
        />
      </Modal>
      <div className='flex justify-between mb-4'>
        <h2>Translate</h2>
        <button onClick={()=> openForm(false, null)} className='ml-auto bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded h-12 mt-auto'>
            เพิ่มคำแปลใหม่
        </button>
      </div>

      {/* Search Box */}
      <div className="mb-4">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="text"
            placeholder="ค้นหาคำไทย..."
            value={searchKeyword}
            onChange={(e) => setSearchKeyword(e.target.value)}
            className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          />
        </div>
      </div>

      <table className="min-w-full bg-white border border-gray-300">
        <thead>
          <tr>
            <th className="px-4 py-2 bg-blue-200 border-b border-gray-300">Thai</th>
            <th className="px-4 py-2 bg-blue-200 border-l border-b border-gray-300">Japanese</th>
            <th className="px-4 py-2 bg-blue-200 border-l border-b border-gray-300"></th>
          </tr>
        </thead>
        <tbody>
          {filteredTranslates.length > 0 ? (
            filteredTranslates.map((item, index) => (
              <tr key={index} className="hover:bg-gray-100">
                <td className="px-4 py-2 border-b border-gray-300">{item.thai}</td>
                <td className="px-4 py-2 border-b border-l border-gray-300">{item.japanese}</td>
                <td className="px-4 py-2 border-b border-l border-gray-300 w-20">
                  <div className="flex items-center space-x-3">
                    <PencilIcon onClick={() => openForm(true, item.id)} className='cursor-pointer flex items-center w-6 h-6 fill-green-600' />
                    <TrashIcon onClick={() => openConfirm(item.id)} className='cursor-pointer flex items-center w-6 h-6 fill-red-600' />
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="px-4 py-8 text-center text-gray-500">
                {searchKeyword ? 'ไม่พบคำที่ค้นหา' : 'ไม่มีข้อมูล'}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default Translate